
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Variables`}</h1>
<p>{`Don't use `}<inlineCode parentName="p">{`var`}</inlineCode>{`. Always use `}<inlineCode parentName="p">{`const`}</inlineCode>{` or `}<inlineCode parentName="p">{`let`}</inlineCode>{`.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? `}<inlineCode parentName="p">{`var`}</inlineCode>{` hoists every assignment to the beginning of the function while `}<inlineCode parentName="p">{`let`}</inlineCode>{` and `}<inlineCode parentName="p">{`const`}</inlineCode>{` are block-scoped. Also, `}<inlineCode parentName="p">{`var`}</inlineCode>{` will silently re-assing any values to the same var.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
function myFunc(arg) {
  var foo = 1;
  var bar = 1;

  if (arg) {
    var foo = 2;
    bar += foo;
  }

  console.log(foo);  // prints 2
  console.log(bar);  // prints 3;

  return bar;
}

// Good
function myFunc(arg) {
  const foo = 1;
  let bar = 1;

  if (arg) {
    const foo = 2;
    bar += foo;
  }

  console.log(foo);  // prints 1
  console.log(bar);  // prints 3;

  return bar;
}

var foo = 'string';
var foo = 'string2';  // will silently replace the value of foo

let foo = 'string';
let foo = 'string2';  // will trigger an error
`}</code></pre>
<p>{`Note that `}<inlineCode parentName="p">{`const`}</inlineCode>{` does not mean constant value, but constant assignment.`}</p>
<blockquote>
<p parentName="blockquote">{`For scalar values however, constant assignment and value can be assumed, since those are immutable.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`const foo = 1;
foo = 3;  // will trigger an error

const bar = { name: 'User' };
bar.name = 'Object';
console.log(bar);  // prints { name: 'Object' }
`}</code></pre>
<p>{`Always use `}<inlineCode parentName="p">{`const`}</inlineCode>{` for every declaration. If there's no way other than re-assigning a reference, then use `}<inlineCode parentName="p">{`let`}</inlineCode>{`.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? This would prevent us re-assigning a different value accidentally to a variable. It will also help us write easier to reason about code.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
let foo = 1;
// ... more code ...
console.log(foo);  // we can't be sure it hasn't been modified and will print 1

// Good
const bar = 1;
// ... more code ...
console.log(bar);  // we can be sure it will print 1
`}</code></pre>
<p>{`Never chain variable assigments.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const a = b = 3;

// Good
const a = 3;
const b = 3;
`}</code></pre>
<p>{`Never use comma operator `}<inlineCode parentName="p">{`,`}</inlineCode>{` when declaring variables.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
let a, b, c;

// Good
let a;
let b;
let c;
`}</code></pre>
<p>{`Try to group `}<inlineCode parentName="p">{`const`}</inlineCode>{` and `}<inlineCode parentName="p">{`let`}</inlineCode>{` logically.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
let items = [1, 2, 3];
const x = 2;
let index = 0;
const y = 4;
let coeff = 0.5;

// Good
const x = 2;
const y = 4;
let items = [1, 2, 3];
let index = 0;
let coeff = 0.5;
`}</code></pre>
<p>{`Avoid linebreaks before or after `}<inlineCode parentName="p">{`=`}</inlineCode>{` in an assignment.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const foo =
  'value';

// Good
const foo = 'value';
`}</code></pre>
<p>{`Never leave unused variables around.`}</p>
<blockquote>
<p parentName="blockquote">{`That includes unused function arguments and unused imports.`}</p>
</blockquote>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;